export default __webpack_public_path__ + "61207e96f6907de73009d66150a8f6b9.jpg";